var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 100,
    viewBox: "0 0 121 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.1891 25.3C95.7891 39.6 37.7891 92.2 21.2891 68.2C6.68906 46.9 55.0891 6.4 78.2891 21.5C79.7891 22.3 81.6891 21.4 81.6891 19.6C81.6891 18.8 81.1891 18.2 80.7891 17.9C54.2891 0.599999 0.389062 45.5 17.6891 70.8C37.4891 99.7 103.989 39 73.1891 21.5C71.8891 20.5 69.7891 21.4 69.7891 23.3C69.7891 24.1 70.2891 25 71.1891 25.3ZM115.507 52.4C111.507 56 106.907 59.3 104.807 58.5C103.307 58 103.507 56.1 104.007 52.8C104.207 50.9 104.507 48.7 104.007 46.9C103.307 44 100.207 42.5 97.807 41.3L96.607 40.7C96.707 40.2 96.707 39.8 96.807 39.4C98.107 29.9 88.307 29.9 88.607 37.7C88.707 39.9 90.007 41.6 91.607 42.8C89.307 51.4 83.907 64 77.507 68.3C77.107 68.6 76.607 69.2 76.607 70C76.607 71.8 78.607 72.7 80.007 71.8C87.007 67.1 92.907 54.1 95.507 45.2C95.607 45.2 95.707 45.3 95.907 45.3C98.107 46.4 99.507 47.1 99.807 48C100.007 48.8 99.807 50.2 99.607 52.1C99.107 55.7 98.407 61 103.207 62.7C107.707 64.4 114.207 59.5 118.407 55.7C120.807 53.7 117.507 50.4 115.507 52.4Z",
    fill: "#30426D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOr);
export default __webpack_public_path__ + "static/media/Or.ba759175e853da5349910b9d6e1b6265.svg";
export { ForwardRef as ReactComponent };